import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-version-asset-list',
  templateUrl: './version-asset-list.component.html',
  styleUrls: ['./version-asset-list.component.scss']
})

export class VersionAssetListComponent implements OnInit {
  @Input() versionId: string = '0';
  @Input() eventId = '';
  @Output() closeDialog = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.closeDialog.emit();
  }

}
